module.exports = __webpack_public_path__ + "img/requestdeneied.4be6a772.svg";